import React from 'react';
import { EmptyBlock } from '../elements/EmptyBlock';

export const FolderEmpty = () => {
    return <EmptyBlock
        minHeight="16"
        title="This folder is empty!"
        subtitle="For now..."
    />;
};
